import React, { useEffect, useState } from "react";
import { Button, Dropdown } from "antd";
import { SunOutlined, MoonOutlined, SyncOutlined } from "@ant-design/icons";
import { useThemeContext } from "@/contexts";
import { getLocalStorage, setLocalStorage } from "@/utils";

type IThemeMode = "auto" | "light" | "dark";

// 用于localStorage存储用户偏好主题的key
const THEME_PERFORMANCE_KEY = "APP_THEME_PERFORMANCE";
// 获取当前用户系统主题
const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
  ? "dark"
  : "light";

export default function ThemeSlot() {
  const { themeMode, setThemeMode } = useThemeContext();
  const [selectedThemeKey, setSelectedThemeKey] = useState<IThemeMode>(
    (getLocalStorage(THEME_PERFORMANCE_KEY) as IThemeMode) || "light",
  ); // 当前选中的主题key（默认light）

  useEffect(() => {
    setLocalStorage("APP_THEME_PERFORMANCE", selectedThemeKey);
    setThemeMode(selectedThemeKey === "auto" ? prefersDark : selectedThemeKey);
  }, [selectedThemeKey]);

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: "auto",
            label: "跟随系统",
            icon: <SyncOutlined />,
          },
          {
            key: "light",
            label: "浅色主题",
            icon: <SunOutlined />,
          },
          {
            key: "dark",
            label: "深色主题",
            icon: <MoonOutlined />,
          },
        ],
        selectedKeys: [selectedThemeKey],
        onClick: (e) => {
          // 菜单切换的时候, 永久切换显示效果, 保存用户偏好配置(localStorage)
          setSelectedThemeKey(e.key as IThemeMode);
        },
      }}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      // trigger={["click"]} // just for debug
    >
      <Button
        shape="circle"
        type="text"
        icon={themeMode === "light" ? <SunOutlined /> : <MoonOutlined />}
        onClick={() => {
          // 点击按钮的时候仅临时切换当前显示效果, 不改变用户偏好配置(localStorage)
          setThemeMode(themeMode === "light" ? "dark" : "light");
        }}
      />
    </Dropdown>
  );
}
